const LOGO_URL = "/logo.png";

export const Logo = ({ className = "", size = "md" }) => {
  const h = size === "lg" ? "h-16 sm:h-20" : size === "sm" ? "h-8" : "h-12 sm:h-14";
  return (
    <img
      src={LOGO_URL}
      alt="Image Reservations"
      className={`${h} w-auto object-contain ${className}`}
      data-testid="brand-logo"
    />
  );
};

export default Logo;
